function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.4
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.956,2.045c0.943-0.943,2.373-1.1,3.493-0.496c-0.132-0.245-0.288-0.481-0.494-0.688c-1.15-1.15-3.032-1.15-4.182,0 l-8.364,8.364l1.183,1.183L22.956,2.045z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.55,26.449c-0.605-1.12-0.448-2.55,0.495-3.494l8.364-8.364l-1.183-1.183l-8.364,8.364c-1.15,1.15-1.15,3.031,0,4.182 v0.001C1.069,26.161,1.305,26.317,1.55,26.449z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.045,6.227c-1.15-1.15-1.15-3.032,0-4.182v0c1.151-1.15,3.032-1.15,4.182,0L5.045,0.862c-1.15-1.15-3.032-1.15-4.182,0v0 c-1.15,1.15-1.15,3.032,0,4.182L2.045,6.227z"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  fill: "#FFFFFF",
  d: "M18.773,14.591l8.364-8.364c1.149-1.15,1.149-3.032,0-4.182c-1.15-1.15-3.032-1.15-4.182,0 l-8.364,8.364L6.228,2.045c-1.15-1.15-3.031-1.15-4.182,0v0c-1.15,1.15-1.15,3.032,0,4.182l8.364,8.364l-8.364,8.364 c-1.15,1.15-1.15,3.032,0,4.181v0.001c1.151,1.149,3.032,1.149,4.182,0l8.364-8.364l8.364,8.364c1.15,1.149,3.031,1.149,4.182,0 c1.149-1.15,1.149-3.032,0-4.182L18.773,14.591z"
});

function SvgIconNavClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    enableBackground: "new 0 0 28 28",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavClose);
export default __webpack_public_path__ + "static/media/icon-nav-close.67388f80.svg";
export { ForwardRef as ReactComponent };